function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Regular/Trash");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Regular/Trash",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "trash-2",
  transform: "translate(2.000000, 1.000000)",
  stroke: "#80A1FE"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Shape",
  strokeWidth: 2,
  points: "0 2.66666667 1.33333333 2.66666667 12 2.66666667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6666667,2.66666667 L10.6666667,12 C10.6666667,12.7363797 10.069713,13.3333333 9.33333333,13.3333333 L2.66666667,13.3333333 C1.930287,13.3333333 1.33333333,12.7363797 1.33333333,12 L1.33333333,2.66666667 M3.33333333,2.66666667 L3.33333333,1.33333333 C3.33333333,0.596953667 3.930287,0 4.66666667,0 L7.33333333,0 C8.069713,0 8.66666667,0.596953667 8.66666667,1.33333333 L8.66666667,2.66666667",
  id: "Shape",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.66666667,6 L4.66666667,10",
  id: "Shape",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.33333333,6 L7.33333333,10",
  id: "Shape",
  strokeWidth: 1.5
})));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.e4c28603.svg";
export { ForwardRef as ReactComponent };